import React, { Component } from 'react';
import ReactFilestack from 'filestack-react';
import config from '../../config';
import get from 'lodash/get';


import {FontAwesomeIcon as FA} from '@fortawesome/react-fontawesome';
import faCamera from '@fortawesome/fontawesome-pro-light/faCamera';
import faTrashAlt from '@fortawesome/fontawesome-pro-light/faTrashAlt';

import classNames from 'classnames';

import preventDefault from '../../utils/preventDefault';


const stopPropagation = (e) => {
  preventDefault(e);
  
  if (e && stopPropagation)
    e.stopPropagation();
}

const avatarFilestackOptions = {
  accept: ["image/*"],
  maxSize: 1024 * 1024 * 2, // 2 mb max file size
  transformations: {
    crop: true,
    circle: false,
    rotate: true
  },
  imageMax: [720, 720]
}

class AvatarUploader extends Component {
  
  render() {
    const { input } = this.props
    
    return (
      <ReactFilestack
        apikey={config.filestackKey}
        actionOptions={avatarFilestackOptions}
        onSuccess={(res) => 
          input.onChange(get(res, 'filesUploaded[0].url', null))
        }
        customRender={({ onPick }) => (
          <div className={classNames({avatar: true, empty: !input.value})} onClick={onPick} style={{backgroundImage: input.value && `url(${input.value})`}}>
            {!input.value && <FA icon={faCamera} className="fa-camera" />}
            {!!input.value && <div className="delete-button service-button" onClick={(e) => {stopPropagation(e); input.onChange(null);}}><FA icon={faTrashAlt} /></div>}
          </div>
        )}
      />
    );
  }
  
}

export default AvatarUploader;


// WEBPACK FOOTER //
// ./src/components/SmartPages/AvatarUploader.js